import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { AppRoutes } from 'utilitys/appRoutes/AppRoutes';

import { PageNotFound } from 'components/common/ErrorPages/pageNotFound';

import { ExcellenceAppsRoutes } from 'components/Dashboards/ExcellenceApps/routes';
import { PortfolioRoutes } from 'components/Dashboards/Portfolio/routes';
import ProjectRoutes from 'components/Dashboards/Project/ProjectWrapper/projectRoutes';

const Dashboards = () => {
    const { path } = useRouteMatch();

    return (
        <Switch>
            <Route path={`${path}/${AppRoutes.EXCELLENCE_APPS}`} component={ExcellenceAppsRoutes} />
            <Route path={`${path}/${AppRoutes.PROJECT}`} component={ProjectRoutes} />
            <Route path={`${path}/${AppRoutes.PORTFOLIO}`} component={PortfolioRoutes} />
            <Route path="*" component={PageNotFound} />
        </Switch>
    );
};

export default Dashboards;
